/**
 * Default logo URL used when no business profile logo is provided
 */
export const DEFAULT_BUSINESS_PROFILE_LOGO =
  'https://res.cloudinary.com/dwx3u2p1d/image/upload/v1767851453/SpritesPlaceholderLogo_g06bwt.png'
